import React from "react";
import { FormHelperText, Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { FormControlStyled } from "./QuestionSelectors.styles";
import { Controller, useFormContext } from "react-hook-form";
import { QuestionTypes, QuestionTypesRu } from "../../../../../static/enums/Questions";
import { requiredQuestionDifficult } from "../../../../../validation/question/rules";
import { requiredQuestionDifficultMessage } from "../../../../../validation/question/errors";

interface ProblemSelectorsProps {
	prefix: string;
}

export default function ProblemSelectors({ prefix }: ProblemSelectorsProps) {
	const { control } = useFormContext();

	return (
		<Grid container item xs={12} justifyContent={"space-between"} alignItems={"center"} wrap={"wrap"}>
			<Controller
				control={control}
				name={`${prefix}difficulty`}
				defaultValue={0}
				{...requiredQuestionDifficult()}
				render={({ field: { value, onChange }, fieldState: { error } }) => (
					<FormControlStyled variant={"outlined"} error={!!error} size={"small"} margin={"dense"}>
						<InputLabel id={"difficulty level"}>Сложность</InputLabel>
						<Select fullWidth labelId={"difficulty level"} label={"Сложность"} onChange={onChange} value={value}>
							<MenuItem value={0}>Не задано</MenuItem>
							<MenuItem value={1}>1 баллов из 10</MenuItem>
							<MenuItem value={2}>2 баллов из 10</MenuItem>
							<MenuItem value={3}>3 баллов из 10</MenuItem>
							<MenuItem value={4}>4 баллов из 10</MenuItem>
							<MenuItem value={5}>5 баллов из 10</MenuItem>
							<MenuItem value={6}>6 баллов из 10</MenuItem>
							<MenuItem value={7}>7 баллов из 10</MenuItem>
							<MenuItem value={8}>8 баллов из 10</MenuItem>
							<MenuItem value={9}>9 баллов из 10</MenuItem>
							<MenuItem value={10}>10 баллов из 10</MenuItem>
						</Select>
						<FormHelperText>{requiredQuestionDifficultMessage(error)}</FormHelperText>
					</FormControlStyled>
				)}
			/>
			<FormControlStyled variant={"outlined"} size={"small"} margin={"dense"}>
				<InputLabel id={"answer type"}>Тип ответа</InputLabel>
				<Controller
					control={control}
					name={`${prefix}class`}
					defaultValue={QuestionTypes.input_text}
					render={({ field: { value, onChange } }) => {
						return (
							<Select labelId={"answer type"} label={"Тип ответа"} onChange={onChange} value={value}>
								{Object.entries(QuestionTypes).map((type) => {
									const [value, _] = type as [QuestionTypes, string];
									return (
										<MenuItem key={value} value={value}>
											{QuestionTypesRu[value]}
										</MenuItem>
									);
								})}
							</Select>
						);
					}}
				/>
			</FormControlStyled>
			<Controller
				control={control}
				name={`${prefix}category`}
				defaultValue={"for_assignments"}
				render={({ field: { value, onChange }, fieldState: { error } }) => (
					<FormControlStyled variant={"outlined"} error={!!error} size={"small"} margin={"dense"}>
						<InputLabel id={"difficulty level"}>Применение задачи</InputLabel>
						<Select
							fullWidth
							labelId={"difficulty level"}
							label={"Применение задачи"}
							onChange={onChange}
							value={value}
						>
							<MenuItem value={"for_assignments"}>Для ДЗ/листков</MenuItem>
							<MenuItem value={"for_test_exams"}>Для пробных экзаменов</MenuItem>
						</Select>
					</FormControlStyled>
				)}
			/>
		</Grid>
	);
}
